export default __webpack_public_path__ + "static/media/no-data.26c60500.svg";